import * as React from 'react';
import { Image, IImageSettings, ImageFetchPriority } from '@msdyn365-commerce/core';
import { IProductListCompactComponentProps } from '../product-list-compact-component';
import { ProductListProduct } from '../../product-list-component/product-list-component';
import { ensureBaseImageUrl } from '../../../shared-utils/image-utilities';

export interface IProductImageProps extends IProductListCompactComponentProps {
    className?: string;
    heading?: string;
    product: ProductListProduct;
}

const ProductImage = (props: IProductImageProps) => {
    const {
        context,
        className,
        heading
    } = props;

    const Width = 150;
    const Height = 150;
    const defaultImageSettings: IImageSettings = {
        viewports: {
            xs: { w: Width, h: Height, q: `w=${Width}px&h=${Height}&q=80&m=0&f=webp`, qe: `t=${Width}h${Height}qhigh` },
            lg: { w: Width, h: Height, q: `w=${Width}px&h=${Height}&q=80&m=0&f=webp`, qe: `t=${Width}h${Height}qhigh` },
            xl: { w: Width, h: Height, q: `w=${Width}px&h=${Height}&q=80&m=0&f=webp`, qe: `t=${Width}h${Height}qhigh` }
        },
        disableLazyLoad: !Boolean(props.imageSettings?.disableLazyLoad),
        lazyload: Boolean(props.imageSettings?.lazyload),
        quality: props.imageSettings?.quality || 80
    };

    const imageUrl = ensureBaseImageUrl(context, props.product.PrimaryImageUrl);

    const contextConfig = context.request.app.config?.placeholderImageName;
    const emptyPlaceHolderImage = contextConfig as string;
    let fallbackImageSource = context?.request.apiSettings.baseImageUrl;
    if (fallbackImageSource?.endsWith('/')) {
        fallbackImageSource = fallbackImageSource.slice(0, -1);
    }
    if (emptyPlaceHolderImage) {
        fallbackImageSource = `${fallbackImageSource}${emptyPlaceHolderImage}`;
    }

    return (
        <Image
            requestContext={context.actionContext.requestContext}
            className={className}
            altText={heading}
            title={heading}
            src={imageUrl || fallbackImageSource}
            fallBackSrc={fallbackImageSource}
            gridSettings={context.request.gridSettings!}
            imageSettings={defaultImageSettings}
            loadFailureBehavior='empty'
            bypassHideOnFailure
            fetchPriority={ImageFetchPriority.High}
            tabIndex={0}
        />
    );
};

export default ProductImage;
